import React from "react";
import {Link} from "react-router-dom";

class Promotion extends React.Component {
  render() {
    const clearStyle = {
      clear: "both"
    };
    const PaddingStyle = {
      paddingLeft: "5%",
      paddingRight: "5%"
    };

    const strongStyle = {
      fontSize: "1.2em"
    };

    const strongStyleBlue = {
      fontSize: "1.2em",
      color: "#0076be"
    };
    return (
        <section className="section" style={{background: "#fff", padding: "60px 0"}}>

          <div className="container vertical-content">
            <div className="col-lg-6">
              <img src="/images/190422-001.jpg" alt="" className="img-fluid mx-auto d-block"/>
            </div>
            <div className="col-lg-6" style={PaddingStyle}>
              <div className="mt-3 features_desc">
                <h1 className="promotitle">Limited Time Promotion #1</h1>

                <div className="col-lg-12 promoitem">
                  <p className="promo-title">U.S.</p>
                  <p className="promo-text">FREE Unlimited U.S. 50GB 4G/LTE data for 30 days<p className="promo-notice">(** After 50GB, data speed limited to max of 128 kbps, for use in U.S. only.<br/>Please check with us for coverage in your location before purchase)</p></p>
                </div>

                <div className="col-lg-12">
                  <div className="promo-separator">And</div>
                </div>

                <div className="col-lg-12 promoitem">
                  <p className="promo-title">Global</p>
                  <p className="promo-text">FREE Limited Global 3GB 4G/LTE data for 30 days<p className="promo-notice">(* Download our App for Data Usages and Instant Recharge options.<br/>The device will not work without a data plan)</p></p>
                </div>

                <div className="col-lg-12 no-padding">
                  <div className="promo-btnBox">
                    <p className="promo-btnBox_text">No SIM Card Roaming Charges International Pocket WiFi Hotspot Device</p>
                    <div style={clearStyle} />
                    {/*<div className="promodollar">$159</div>*/}
                    {/*<div className="promodollar">$165.90</div>*/}
                    <div className="promodollar">$169</div>
                    <div className="promoright">
                      <div className="header_btn">
                        <Link to="/buy/device/159" className="btn btn-custom">BUY NOW</Link>
                      </div>
                    </div>
                  </div>
                </div>

                <div style={clearStyle} />
              </div>
            </div>
          </div>

        </section>
    );
  }
}

export default Promotion;



// WEBPACK FOOTER //
// ./src/layout/HowItWorks.js